// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xlzak","comment":"styles_comment__hEoEn"};